import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';

import { hideDialog, showDialog } from '../../../redux/actions/dialogs';
import ReduxDialog from '../../Common/ReduxDialog/index';
import { editTaskRoutine } from '../../../redux/routines';

import ItemsGrid from './ItemsGrid/index';
import styles from './styles';
import NotesTable from '../NotesGrid/index';
import { SEND_EMAIL_DIALOG, SEND_SMS_DIALOG, TASK_DIALOG } from '../../../redux/constants/dialogs';
import { getDialogContextValue } from '../../../redux/selectors';
import { formatLocation, toJS } from '../../../utils/helper';
import { Grid } from '@material-ui/core';
import { renderContactInput, renderLocationInput } from '../../../utils/reduxforms';
import TaskTimeline from './TaskTimeline/index';
import { toArray } from '../../../utils/helper';
import { name } from '../../../utils/helper';

class TaskDialog extends Component {
  state = {
    tab: 0,
  };

  handleDiscard = () => {
    this.props.hideDialog(TASK_DIALOG);
  };

  handleSave = () => {
    this.props.onRequestClose();
  };

  handleSkipStage = (a, b, c) => {
    console.log('handleSkipStage', a, b, c);
  };

  handleCompleteStage = (a, b, c) => {
    console.log('handleSkipStage', a, b, c);
  };

  handleSendSMS = (contact) => {
    if (contact.mobile) {
      const { task, job } = this.props;
      this.props.showDialog(SEND_SMS_DIALOG, { contact, params: { task, job } });
    }
  }

  handleSendEmail = (contact) => {
    if (contact.email) {
      const { task, job } = this.props;
      this.props.showDialog(SEND_EMAIL_DIALOG, { contact, params: { task, job } })
    }
  }

  render() {
    const { job, task, submit } = this.props;
    const { tab } = this.state;
    // console.log('TASK', task ? task.toJS() : null);

    if (!task) {
      return null;
    }

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={this.handleDiscard}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        onClick={() => submit('task')}
      >Save</Button>,
    ];

    const title = task.origin && task.destination ? `${formatLocation(task.origin)} to ${formatLocation(task.destination)}` : 'Task'

    return (
      <ReduxDialog
        title={title}
        subTitle={task.contact ? name(task.contact) : null}
        actions={actions}
        modal={false}
        name={TASK_DIALOG}
        onRequestClose={this.handleDiscard}
        autoScrollBodyContent
        fullWidth
        maxWidth="md"
      >
        <Form name="Task">
          <Grid container spacing={8} style={styles.container}>
            <Grid item xs={6}>
              <Paper style={styles.paper}>
                <Field
                  name="origin"
                  label="Origin"
                  component={renderLocationInput}
                />
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper style={styles.paper}>
                <Field
                  name="destination"
                  label="Destination"
                  component={renderLocationInput}
                />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper style={styles.paper}>
                <Field
                  name="contact"
                  label="Contact"
                  component={renderContactInput}
                  onSendSms={this.handleSendSMS}
                  onSendEmail={this.handleSendEmail}
                />
              </Paper>
            </Grid>
          </Grid>

          <div>
            <AppBar position="static">
              <Tabs value={tab} onChange={(evt, tab) => this.setState({ tab })}>
                <Tab label="Items"/>
                <Tab label="Notes"/>
                <Tab label="Timeline"/>
              </Tabs>
            </AppBar>

            {tab === 0 ? <ItemsGrid job={job} task={task}/> : null}
            {tab === 1 ? <NotesTable notes={toArray(task.notes || {})}/> : null}
            {tab === 2 ? <TaskTimeline job={job} task={task}/> : null}
          </div>
        </Form>
      </ReduxDialog>
    );
  }
}

TaskDialog.propTypes = {
  job: PropTypes.object.isRequired,
  task: PropTypes.object,
  hideDialog: PropTypes.func.isRequired,
  // onRe,questClose: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: TASK_DIALOG,  // a unique identifier for this form
  // enableReinitialize: true,
  onSubmit: (values, dispatch, props) => {
    const task = values;
    props.onRequestClose();
    return dispatch(editTaskRoutine.trigger(task));
  },
})(TaskDialog);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hideDialog,
    showDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  const job = getDialogContextValue(state)(TASK_DIALOG, 'job');
  console.log('job2', job);
  const task = getDialogContextValue(state)(TASK_DIALOG, 'task');
  return {
    task: toJS(task),
    job: toJS(job),
    initialValues: task,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskDialog/index.js